var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFocus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 224.72727272727286 224.80572432009103",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "rect-1",
    opacity: 1,
    x: 59.999999999999886,
    y: 60,
    width: 104.72727272727275,
    height: 104.80572432009063
  }), /*#__PURE__*/React.createElement("filter", {
    id: "filter-2",
    filterUnits: "userSpaceOnUse",
    x: "-50%",
    y: "-50%",
    width: "200%",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feOffset", {
    in: "SourceAlpha",
    result: "shadow-1-feOffset-shadow",
    dx: 0,
    dy: 0
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadow-1-feOffset-shadow",
    result: "shadow-1-feGaussianBlur-shadow",
    stdDeviation: 30
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadow-1-feGaussianBlur-shadow",
    result: "shadow-1-feColorMatrix-shadow",
    type: "matrix",
    values: "0 0 0 0 0  0 0 0 0 0.7333333333333333  0 0 0 0 1  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-3",
    opacity: 1,
    fillRule: "evenodd",
    d: "M107.12658151897858,153.20547793793742 L117.60069120829495,154.00096293134683 L117.60069120829495,164.80572432009063 L107.12658151897858,164.80572432009063 L107.12658151897858,153.20547793793742Z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-4",
    x1: 0.5,
    y1: 1,
    x2: 0.5,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "rgb(0,77,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.754,
    stopColor: "rgb(0,120,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.451,
    stopColor: "rgb(0,168,255)",
    stopOpacity: 1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "rgb(0,186,255)",
    stopOpacity: 1
  })), /*#__PURE__*/React.createElement("path", {
    id: "path-5",
    opacity: 1,
    fillRule: "evenodd",
    d: "M112.36363181719742,128.12348414000735 C121.03831443438492,128.12348414000735 128.07249412188492,121.08402491149172 128.07249412188492,112.40287256774172 C128.07249412188492,103.7216897064136 121.04057273516617,96.68223047789797 112.36363181719742,96.68223047789797 C103.68669089922867,96.68223047789797 96.65476951250992,103.7216897064136 96.65476951250992,112.40287256774172 C96.65476951250992,121.08402491149172 103.68894920000992,128.12348414000735 112.36363181719742,128.12348414000735 L107.12657127032242,112.4028420501636 C107.12657127032242,115.29657984313235 109.47209128985367,117.64383936461672 112.36363181719742,117.64383936461672 L117.60069236407242,112.4028420501636 C117.60069236407242,109.50913477477297 115.25517234454117,107.1618752532886 112.36363181719742,107.1618752532886 C109.47209128985367,107.1618752532886 107.12657127032242,109.50913477477297 107.12657127032242,112.4028420501636 L112.36363181719742,128.12348414000735Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path-6",
    opacity: 1,
    fillRule: "evenodd",
    d: "M164.72727272727263,107.1618842179597 L153.92829513954158,107.1618842179597 C151.56436277235315,88.1993665779626 136.5467105605266,73.17046458653495 117.59838718064606,70.80476138874347 L117.59838718064606,60 L107.12658151897811,60 L107.12658151897811,70.80706714234756 C88.17825813909757,73.17046458653495 73.16060592727102,88.1993665779626 70.79667356008261,107.1618842179597 L59.999999999999886,107.1618842179597 L59.999999999999886,117.64153434852714 L70.79897758773095,117.64153434852714 C73.37488049856587,138.32414417717183 91.000692008304,154.32607418952347 112.36363636363626,154.32607418952347 C114.13773765285174,154.32607418952347 115.88419061028722,154.2153980165274 117.60069120829439,154.00096293134743 L107.12888554662646,143.4106366277839 C92.26790721488646,140.91581122816365 80.94591535098411,127.9828392628495 80.94591535098411,112.40286216004546 C80.94591535098411,95.03823176767945 95.01200414404963,80.961606014739 112.36363636363626,80.961606014739 C129.7152685832229,80.961606014739 143.78135737628844,95.03823176767945 143.78135737628844,112.40286216004546 C143.78135737628844,124.04000059986372 137.46371356456268,134.2014567330674 128.07249686996235,139.63842373150044 L128.07249686996235,151.27786792492276 C141.87592651111805,145.68641543501604 152.01825621907454,132.94482101884097 153.92599111189324,117.64384010213124 L164.72727272727263,117.64384010213124 "
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#rect-1",
    fill: "black",
    filter: "url(#filter-2)",
    stroke: "black",
    strokeOpacity: 0,
    strokeWidth: 0
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-3",
    fill: "url(#linearGradient-4)"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6",
    fill: "rgb(0,186,255)",
    fillOpacity: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFocus);
export default __webpack_public_path__ + "static/media/focus.a70c488583a677d07ce289520ea7d3ff.svg";
export { ForwardRef as ReactComponent };